import { ErpDiv, ErpP } from "@/components/erp";
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { useTenantImages } from '@/hooks/useTenantImages'

export const Footer: React.FC = () => {
  const { t } = useTranslation()
  const user = useAppSelector((state) => state.auth.user) as Record<string, unknown> | Record<string, never>
  useTenantImages();

  new Date().getFullYear();

  // No user means nothing to render: bail BEFORE touching the image hook, which
  // would fire a preview request for an undefined logo.
  if (!user || !user.id) return null

  
  const footer = (user.footer as string) || ''
  

  return (
    <ErpDiv className="footer_wrap text-muted-foreground border-t border-border mt-4">
      <ErpDiv className="app-footer flex items-center justify-end py-4">
        <ErpP className="text-sm font-medium m-0 text-end">{footer ? t(footer) : ''}</ErpP>
      </ErpDiv>
    </ErpDiv>
  );
}

export default Footer
